import { useState } from 'react';

type DailyMetrics = {
  sleepStage: boolean;
  noise: boolean;
  posture: boolean;
  temperature: boolean;
};

type UseDailyMetricsReturn = {
  selectedMetrics: DailyMetrics;
  handleMetricToggle: (metric: keyof DailyMetrics) => void;
  hasSelectedMetrics: boolean;
};

export const useDailyMetrics = (): UseDailyMetricsReturn => {
  const [selectedMetrics, setSelectedMetrics] = useState<DailyMetrics>({
    sleepStage: false,
    noise: false,
    posture: false,
    temperature: false,
  });

  const handleMetricToggle = (metric: keyof DailyMetrics) => {
    setSelectedMetrics(prev => ({
      ...prev,
      [metric]: !prev[metric]
    }));
  };

  const hasSelectedMetrics = Object.values(selectedMetrics).some(v => v);

  return {
    selectedMetrics,
    handleMetricToggle,
    hasSelectedMetrics,
  };
};
